(function () {
  var DEFAULT_SPEED = 100;
  var resizeTimer;

  function resetMarquee(strip, inner) {
    strip.classList.remove('has-marquee');
    inner.classList.remove('is-marquee');
    inner.style.removeProperty('animation-duration');
    inner.style.removeProperty('--elvtd-track-width');
    inner.querySelectorAll('[data-marquee-clone]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function initMarquee(strip) {
    var inner = strip.querySelector('.elvtd-icons-strip__inner');
    if (!inner) return;

    resetMarquee(strip, inner);

    var contentWidth = inner.scrollWidth;
    if (contentWidth <= inner.clientWidth) return;

    var speed = parseFloat(strip.dataset.speed) || DEFAULT_SPEED;

    var originals = Array.from(inner.children);

    var joinDivider = document.createElement('div');
    joinDivider.className = 'elvtd-icons-strip__divider';
    joinDivider.setAttribute('data-marquee-clone', '');
    joinDivider.setAttribute('aria-hidden', 'true');
    inner.appendChild(joinDivider);

    var slideWidth = inner.scrollWidth;

    originals.forEach(function (child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      inner.appendChild(clone);
    });

    inner.style.setProperty('--elvtd-track-width', '-' + slideWidth + 'px');
    inner.style.animationDuration = (slideWidth / speed) + 's';
    strip.classList.add('has-marquee');
    inner.classList.add('is-marquee');
  }

  function initAll() {
    document.querySelectorAll('.elvtd-icons-strip').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var strip = e.target.querySelector('.elvtd-icons-strip');
    if (strip) initMarquee(strip);
  });
})();
